import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledModalBody,
  StyledModalHeader,
  Title,
  SubTitle,
  StyledModal,
  StyledModalFooter,
} from './ModalPage.styled';

const Page = (props) => {
  const { header, subHeader, children, actionButton, footer } = props;

  return (
    <StyledModal isOpen={true} backdrop={false} fade={false} centered size="lg">
      <StyledModalHeader>
        <Title>{header}</Title>
        <SubTitle>{subHeader}</SubTitle>
      </StyledModalHeader>
      <StyledModalBody>{children}</StyledModalBody>
      <StyledModalFooter>
        <>{actionButton}</>
        <div>{footer}</div>
      </StyledModalFooter>
    </StyledModal>
  );
};

Page.defaultProps = {
  header: '',
  subHeader: <></>,
  children: <></>,
  actionButton: <></>,
  footer: <></>,
};

Page.propTypes = {
  header: PropTypes.string,
  subHeader: PropTypes.element,
  children: PropTypes.element,
  actionButton: PropTypes.element,
  footer: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
};
export default Page;
